import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Receive Stock',
    id: 'P2PZI7',
    description: 'Title of the modal',
  },
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close Scan To Receive drawer',
    id: 'j2p/QE',
    description: 'Aria label for the close button',
  },
  scanInstructions: {
    defaultMessage: 'Scan or enter UPC/SKU and adjust any details as needed',
    id: 'wNMRKE',
    description: 'Instructions for scanning products',
  },
  shareFeedback: {
    description: 'Button to open new form to share feedback',
    defaultMessage: 'Share feedback',
    id: 'NZNdrk',
  },
  bannerContent: {
    defaultMessage: '<b>Early Access Preview:</b> This feature is free for all ShipStation users for a limited time.',
    id: 'IF8pvW',
    description: 'Helper text with link to article',
  },
  selectWarehouse: {
    defaultMessage: 'Select warehouse',
    id: 'u13gle',
    description: 'Label for warehouse selection',
  },
  addProducts: {
    defaultMessage: 'Add products',
    id: 'YqqSd5',
    description: 'Label for adding products',
  },
  notes: {
    defaultMessage: 'Notes',
    id: 's04fBz',
    description: 'Label for notes field',
  },
  optional: {
    defaultMessage: '(Optional)',
    id: 'nxaRya',
    description: 'Text indicating a field is optional',
  },
  addedProducts: {
    defaultMessage: 'Added products ({productCount})',
    id: 'X63Fh6',
    description: 'Title for the added products section',
  },
  clearAll: {
    defaultMessage: '{icon} Clear All',
    id: 'TpY0n2',
    description: 'Text for Clear All button',
  },
  showAdvancedFields: {
    defaultMessage: 'Show advanced inventory fields',
    id: 't8DUxs',
    description: 'Message for checkbox to toggle advanced fields',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'ti5TEd',
    description: 'Text for cancel button',
  },
  submit: {
    defaultMessage: 'Add Stock',
    id: 'VV1uam',
    description: 'Text for submit button',
  },
  startProcessingProductsTitle: {
    defaultMessage: 'Processing scanned products',
    id: 'jkq+Yl',
    description: 'Information in notification title about starting the scan to receive process',
  },
  startProcessingProductsContent: {
    defaultMessage:
      'We are currently processing your stock submissions. You will receive an additional update when this has been successfully completed.',
    id: 'dY0ELP',
    description: 'Information in notification content about starting the scan to receive process',
  },
  productFoundAndAdded: {
    defaultMessage: 'Product {name} scanned. Quantity increased to {quantity}{hasUom, select, true { ({eaches} Each)} other {}}.',
    id: 'EtXUcF',
    description: 'Success content when product is found and added, with optional total Each count for unit-of-measure rows',
  },
  errorSubmitFailedTitle: {
    defaultMessage: 'Submit Error',
    id: 'XMOMEz',
    description: 'Submit error title',
  },
  errorSubmitFailedContent: {
    defaultMessage: 'Failed to submit received products. Please try again',
    id: 'g4VpU0',
    description: 'Submit error content',
  },
  scanToReceiveSuccessTitle: {
    description: 'Notification title when job is completed',
    defaultMessage: 'Product stocks updated',
    id: '5sbm4S',
  },
  scanToReceiveSuccessContent: {
    description: 'Notification content when job is completed',
    defaultMessage: 'Your inventory counts have been successfully updated.',
    id: 'SeeJiS',
  },
  scanToReceiveFailTitle: {
    description: 'Notification title when job fails',
    defaultMessage: 'Product stocks update failed',
    id: 'A20Z/Z',
  },
  scanToReceiveFailContent: {
    description: 'Notification content when job fails',
    defaultMessage: 'There was an error updating your inventory counts. Please try again.',
    id: 'x904nS',
  },
  confirmationModalHeader: {
    description: 'Confirmation modal header',
    defaultMessage: 'Clear the products',
    id: 'damKpm',
  },
  confirmationModalContent: {
    description: 'Content inside confirmation modal',
    defaultMessage: 'Are you sure you want to clear the products?',
    id: 'itlCuT',
  },
  confirm: {
    description: 'Button to confirm action inside modal',
    defaultMessage: 'Confirm',
    id: 'vz7KNJ',
  },
  modalCancel: {
    description: 'Select a label modal cancel button',
    defaultMessage: 'Cancel',
    id: '0RxN+7',
  },
  modalConfirm: {
    description: 'Select a label modal confirm change button',
    defaultMessage: 'Confirm',
    id: 'PC5zxs',
  },
  modalTitle: {
    description: 'Title of the modal when changing warehouse',
    defaultMessage: 'Warehouse change',
    id: 'DdwaMg',
  },
  modalMessage: {
    description: 'Message in modal when changing warehouse',
    defaultMessage: 'Do you want to change warehouse? It will clear all products locations.',
    id: 'uwfIou',
  },
  tagText: {
    description: 'Text for the earky access chip',
    defaultMessage: 'Early Access',
    id: 'oosyM7',
  },
  totalEaches: {
    defaultMessage: '{count} Eaches',
    description: 'Total eaches count shown in the added products header',
    id: 'rIeMC2',
  },
});
